export const fetchLeetcodeStats = async (uuid: string) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API}/leetcode/${uuid}`);
    if (!response.ok) {
      throw new Error('Failed to fetch LeetCode stats')
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching LeetCode stats:', error)
    throw error
  }
}